import FileUploader from "devextreme-react/file-uploader";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { appInfo } from "../../../AppInfo";
import { mucPhaiThuApi } from "../../../api/mucPhaiThuApi";
import { tbtpApi } from "../../../api/tbtpApi";
import DataGrid from "../../../components/data-grid";
import { IDataGridColumn } from "../../../components/data-grid/type/IDataGridProps";
import { DefaultPopup } from "../../../components/modal";
import Button from "../../../components/ui/button/Button";
import ModalActions from "../../../components/ui/modal/ModalActions";
import { showNotify } from "../../../helpers/toast";
import { sf_tbtp_viewmodel } from "../../../models/response/tbtp/sf_tbtp";
import { TBTPEditModal } from "../../tbtp/edit_tbtp_modal";

type KhoanNopImportModalProps = {
  onClose: () => void;
  onSuccess: () => void;
  nam_hoc: string;
  dm_coso_id: number;
  animationOf: string;
};
type KhoanNopImportModalState = {
  file_name: string;
  sheets: any[];
  sheet_index: number;
  data_source: any[];
  root_file_name: string;
};
const initialState: KhoanNopImportModalState = {
  data_source: [],
  file_name: "",
  sheet_index: -1,
  sheets: [],
  root_file_name: ""
};
export const KhoanNopImportModal = (
  props: KhoanNopImportModalProps
) => {
  const [formData, SetFormData] =
    useState<KhoanNopImportModalState>(initialState);
  const [isLoading, SetIsLoading] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [tbtpView, SetTBTPView] = useState<sf_tbtp_viewmodel | undefined>(undefined);

  const onClose = useCallback(() => {
    window.animationHidePopup(props.animationOf || "");
    setTimeout(() => {
      props.onClose();
    }, 500);
  }, [props.animationOf]);

  const { file_name, sheets, sheet_index, data_source, root_file_name } = formData;
  useEffect(() => {
    if (file_name) {
      reloadSheets();
    }
  }, []);
  useEffect(() => {
    if (file_name !== "" && sheets.length > 0 && sheet_index >= 0) {
      reloadDatas();
    }
  }, [file_name, sheet_index, sheets]);

  const errr_code = useMemo(() => {
    const count = data_source.filter((x) => x.err !== "").length;
    if (count > 0) {
      return `Có ${count} dòng không hợp lệ, vui lòng kiểm tra lại dữ liệu`;
    }
    return "";
  }, [data_source]);

  const reloadSheets = async () => {
    const res = await mucPhaiThuApi.getSheets(file_name);
    if (res.is_success) {
      SetFormData({ ...formData, sheets: res.data });
      if (res.data.length >= 1) {
        SetFormData({ ...formData, sheet_index: 0 });
      }
    }
  };
  const reloadDatas = async () => {
    SetIsLoading(true);
    const res = await mucPhaiThuApi.readFiles_khoannop_v2({
      file_name: file_name,
      sheet_index: sheet_index,
      nam_hoc: props.nam_hoc,
      dm_coso_id: props.dm_coso_id, root_file_name: root_file_name
    });
    SetIsLoading(false);
    if (res.is_success) {
      SetFormData({ ...formData, data_source: res.data });
    } else {
      showNotify({
        message: res.message || "Có lỗi, vui lòng kiểm tra lại sheet",
        type: "error",
      });
      SetFormData({ ...formData, data_source: [] });
    }
  };
  const handleSaveChanges = async () => {
    setIsSaving(true);
    const res = await mucPhaiThuApi.import_khoannop_v2({
      file_name: file_name,
      sheet_index: sheet_index,
      nam_hoc: props.nam_hoc,
      dm_coso_id: props.dm_coso_id, root_file_name: root_file_name
    });
    setIsSaving(false);
    if (res.is_success) {
      showNotify({ message: "Import thành công", type: "success" });
      props.onSuccess();
    } else {
      showNotify({ message: res.message || "Có lỗi", type: "error" });
    }
  };
  const btnPreview_click = async (data: any) => {
    const res = await tbtpApi.select_by_id(data.TBTP_Preview)
    if (res.is_success) {
      SetTBTPView(res.data)
    }
  };
  const onUploaded = (e: any) => {
    if (e && e.request && e.request.response) {
      const res = JSON.parse(e.request.response);
      if (res.is_success) {
        SetFormData({
          ...formData,
          file_name: res.data.url,
          sheets: res.data.sheets,
          sheet_index: res.data.sheets.length > 0 ? 0 : -1,root_file_name: e.file.name,
        });
        //SetFormData({ ...formData, file_name: res.data[0].file_name_uploaded })
      }
    }
  };
  const columns: IDataGridColumn[] = useMemo(() => {
    const objectData = data_source[0];
    const excludedFields = ["ID", "Ma_hoc_sinh", "Ma_hinh_thuc_thanh_toan", "Ma_chuan_chi", "Noi_dung", "Ngay_thu_thuc_te", "TBTP", "TBTP_Preview", "id", "err"];

    const generatedColumns: IDataGridColumn[] = [
      { dataField: "id", caption: "TT", width: 80, align: "center" },
      { dataField: "Ma_hoc_sinh", caption: "Mã HS", width: 150, align: "center" },
      { dataField: "Ma_hinh_thuc_thanh_toan", caption: "Mã hình thức thanh toán", width: 120, align: "center" },
      { dataField: "Ma_chuan_chi", caption: "Mã chuẩn chi", width: 150, align: "center" },
      { dataField: "Noi_dung", caption: "Nội dung", minWidth: 200, align: "center" },
      { dataField: "Ngay_thu_thuc_te", caption: "Ngày thu thực tế", width: 200, align: "center" },
      {
        dataField: "TBTP_Preview",
        caption: "TBTP Preview",
        minWidth: 100,
        align: "center",
        cellRender: (rowData: any) => (
          <span style={{ cursor: 'pointer' }} onClick={() => btnPreview_click(rowData)}>
            <i aria-hidden="true" className="fa fa-eye" style={{ color: '#54CA7D' }}></i>
          </span>
        ),
      },
      { dataField: "TBTP", caption: "TBTP", minWidth: 150, align: "right" },
    ];

    for (const key in objectData) {
      if (objectData.hasOwnProperty(key) && !excludedFields.includes(key)) {
        generatedColumns.push({ dataField: key, caption: key, width: 100, align: "center" });
      }
    }

    generatedColumns.push({
      dataField: "err",
      caption: "Thông tin lỗi",
      minWidth: 400,
      align: "center",
      cellRender: (rowData: any) => (
        <span style={{ color: rowData.value ? 'red' : 'inherit' }}>{rowData.value}</span>
      ),
    });

    return generatedColumns;
  }, [data_source]);
  return (
    <DefaultPopup
      maxWidth={1200}
      title={`Import chi tiết khoản năm học ${props.nam_hoc}`}
    >
      <div>
        <div className="pop-up-form">
          <div className="row">
            <div className="col-md-12">
              <div className="form-inline" style={{ width: "100%" }}>
                {file_name === "" && (
                  <div className="form-group" style={{ width: "50%" }}>
                    <FileUploader
                      multiple={false}
                      accept={".xls,.xlsx"}
                      uploadMode={"instantly"}
                      uploadHeaders={{
                        Authorization: `Bearer ${localStorage.access_token}`,
                      }}
                      uploadUrl={`${appInfo.baseApiURL}/sf-mucphaithu/upload_file`}
                      uploadMethod="POST"
                      showFileList={false}
                      onUploaded={onUploaded}
                      labelText="hoặc kéo thả file tại đây để upload"
                      selectButtonText="Chọn file"
                    />
                  </div>
                )}
                <div
                  className="form-group"
                  style={{ flexFlow: "row-reverse", width: "100%" }}
                >
                  <a
                    href="../../template/template_import_khoannop.xlsx"
                    target="_blank"
                  >
                    Tải file mẫu
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              {errr_code && (
                <p className="text-danger padding-top-1rem">{errr_code}</p>
              )}
            </div>
            <div className="col-md-12 padding-top-1rem">
              <DataGrid
                dataSource={data_source}
                columns={columns}
                height={window.innerHeight - 350}
                filterRow={{ enable: true }}
                searchEnable={true}
                paging={{ enable: true, pageSize: 20 }}
              />
            </div>
            {tbtpView && <TBTPEditModal
              onCancel={() => { SetTBTPView(undefined) }}
              isReadOnly={true}
              sf_tbtp={tbtpView}
            />}
          </div>
        </div>
        <ModalActions>
          <Button variant="default" onClick={onClose}>Đóng</Button>
          <Button
            variant="primary"
            onClick={handleSaveChanges}
            isLoading={isSaving}
            disabled={errr_code !== "" || isSaving}
          >
            Cập nhật
          </Button>
        </ModalActions>
      </div>
    </DefaultPopup>
  );
};
